<div class="contact-page">
  <div class="contact-content">
    <div class="left-part">
      <app-contact-info [showFooterText]="showFooterText" class="app-contact"></app-contact-info>
      <div class="concern">
        <div class="title">Schreiben Sie uns eine Nachricht</div>
        <div class="description">Wir sind jederzeit für Sie erreichbar und kümmern uns um alle Fragen und Anregungen.</div>
        <div class="description">Einfach. Schnell. Zuverlässig. Lassen Sie uns wissen, wie wir lhnen helfen können.</div>
        <div dropdown>
          <mat-form-field class="form-field-class" floatLabel="never">
            <mat-label>Bitte selektieren</mat-label>
            <mat-select matNativeControl required [(value)]="selectedConcernType">
              <mat-option
                role="menuitem"
                *ngFor="let contactType of contactTypes; trackBy: trackByFn"
                value="{{ contactType.id }}"
                href="javascript:void(0);"
                (click)="setType(contactType)"
              >
                {{ contactType.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <div class="label">Nachricht*</div>
          <textarea class="text-area" placeholder="Nachricht eingeben" [(ngModel)]="content" autocomplete="off"></textarea>
        </div>
        <div class="button">
          <button class="btn btn-outline-primary btn-send" (click)="sendEmail()">{{ 'module.contact.sendEmailBtnText' | translate }}</button>
        </div>
      </div>
    </div>
    <div class="right-part">
      <app-kam-contact-info
        *ngIf="municipalityId && !!authService.permissions.CONTACT_KAM_INFO"
        [municipalityId]="municipalityId"
        (kamInitialized)="setKamUser($event)"
      ></app-kam-contact-info>
      <!-- USE DB PERMISSION WHEN ELB DB IS READY ELB_CONTACT_INFO-->
    </div>
  </div>
</div>
